import { SearchableSelect, SearchableSelectWrapperProps } from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { useUserSelectOptions } from "components/UI/Selects/UserSelectSearchable/useUserSelectOptions.ts";

type UserSelectSearchableProps = SearchableSelectWrapperProps & {
    roleId?: string;
};

export const UserSelectSearchable = ({ roleId, ...props }: UserSelectSearchableProps) => {
    const hookResult = useUserSelectOptions({ roleId });

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.user"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
